export default {
    fields: [
        {
            key: "key",
            label: "field",
            sorter: false,
            filter: false,
        },
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label: "options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
        },
    ],
    items: []
}